export default __webpack_public_path__ + "static/media/door-to-door.f369b300.svg";